import * as React from "react";
import { QuantitySelector } from "./quantity_selector";
import { EngravingControls } from "client/pages/quick/engraving_controls";
import { If } from "shared/components";
import { useWhitelabel } from "client/hooks";
import { EngravingFormDispatch, EngravingFormState } from  "./reducers";
import { Option } from "@nozzlegear/railway";

type Props = {
    signaturePortraitsOnly: boolean
    state: EngravingFormState
    dispatch: EngravingFormDispatch
}

export function GenericFormControls(props: Props): React.ReactElement {
    const whitelabel = useWhitelabel();
    const { state, dispatch } = props;
    let leftLabel: string;
    let rightLabel: Option<string>;

    if (props.signaturePortraitsOnly === true) {
        leftLabel = "Total Portraits:";
        rightLabel = Option.ofNone();
    } else if (whitelabel.companyName === "sci") {
        leftLabel = "Total Packages:";
        rightLabel = Option.ofSome("(1 Portrait and 5 Portrait Cards per package)");
    } else {
        leftLabel = "Total Portraits:";
        rightLabel = Option.ofNone();
    };

    return (
        <div key={"generic-form-controls"}>
            <QuantitySelector
                min={1}
                max={10}
                quantity={state.quantity}
                onChange={i => dispatch({ type: "setQuantity", value: i })}
                leftLabel={leftLabel}
                rightLabel={rightLabel}
            />
            <If condition={whitelabel.companyName === "sci" && props.signaturePortraitsOnly === true}>
                <EngravingControls
                    forSignaturePortraits={props.signaturePortraitsOnly === true}
                    name={state.engravingName}
                    date1={state.engravingDate1}
                    date2={state.engravingDate2}
                    sentiment={state.engravingSentiment}
                    onNameChanged={v => dispatch({ type: "setEngravingName", value: v })}
                    onDate1Changed={v => dispatch({ type: "setEngravingDate1", value: v })}
                    onDate2Changed={v => dispatch({ type: "setEngravingDate2", value: v })}
                    onSentimentChanged={v => dispatch({ type: "setEngravingSentiment", value: v })}
                />
            </If>
        </div>
    );
};

